<template>
    <div class="propertySearch">
        <div>
            Refine or broaden your search by adjusting your filters accordingly with an advanced search.
            <button
                v-text="'Advanced search'"
                @click="view = VIEWS.form"
                class="open-search"
            />
        </div>
        <filter-summary
            :criteria="criteria"
            :towns="towns"
            :n-results="pagination.TotalRows"
            @show-search-form="view = VIEWS.form"
        />

        <search-form
            v-show="view === VIEWS.form"
            v-model="criteria"
            :towns="towns"
            :n-results="pagination.TotalRows"
            :loading="!!requestController"
            @input="updateCriteria"
            @close="view = VIEWS.results"
            @reset="resetSearch"
        />

<!--TODO        <search-sort v-model="sort" />-->

        <search-results
            :results="results"
            :pagination="pagination"
            :loading="!!requestController"
            @page="loadResultsPage"
            @toggle-hide="toggleHide"
            @toggle-favorite="toggleFavorite"
        />

        <back-to-top />
    </div>
</template>

<script>
import axios from 'axios';
import FilterSummary from './FilterSummary';
import SearchForm from './SearchForm';
import SearchSort from './SearchSort';
import SearchResults from './SearchResults';
import debounce from 'lodash.debounce';
import BackToTop from '../../../_components/BackToTop';
// import { library } from '@fortawesome/fontawesome-svg-core'
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// import { faSpinner, faCircleXmark } from '@fortawesome/free-solid-svg-icons'
// library.add(faSpinner, faCircleXmark);

axios.defaults.baseURL = process.env.MIX_API_BASE_URL;

export default {
    components: {
        BackToTop,
        FilterSummary,
        SearchForm,
        SearchSort,
        SearchResults,
        // FontAwesomeIcon,
    },
    data() {
        return {
            view: null,
            towns: [],
            criteria: null,
            sort: null, // TODO

            requestController: null,

            pagination: {},
            results: [],
            loading: true,
        };
    },
    computed: {
        favorites() {
            return this.results.filter(property => property.favorite);
        },
        suppressions() {
            return this.results.filter(property => property.suppressed);
        },
    },
    watch: {
        sort(cur) {
            window.localStorage.setItem('property-sort', cur);
            this.debouncedSearch();
        },
        // 'criteria.myTowns': {
        //     deep: true,
        //     handler(myTowns) {
        //         if (myTowns.filter(elm => elm.name.trim() === '').length === 0) {
        //             this.criteria.myTowns.push({show: false, name: ''});
        //         }
        //     },
        // },
    },
    methods: {
        updateCriteria(criteria) {
            window.localStorage.setItem('property-criteria', JSON.stringify(criteria))
            Object.assign(this.criteria, JSON.parse(JSON.stringify(criteria)));
            this.debouncedSearch();
        },
        resetCriteria() {
            this.criteria = Object.assign({}, {
                n_people: null,
                beds_min: null,
                beds_max: null,
                baths_min: null,
                baths_max: null,
                pets: null,
                smoking: null,
                keywords: null,

                towns: [],
                // myTowns: [
                //     {show: false, name: ''},
                // ],
                locales: [],
                amenities: [],

                dates_type: null,
                date_in: null,
                date_out: null,
                n_days: null,
                date_earliest: null,
                date_latest: null,

                rate_type: 'weekly',
                rate_min: null,
                rate_max: null,
            });
            window.localStorage.setItem('property-criteria', JSON.stringify(this.criteria))
        },
        resetSearch() {
            this.resetCriteria();
            this.debouncedSearch();
        },
        loadResultsPage(page) {
            this.pagination.CurrentPage = page;
            this.debouncedSearch(page);
        },
        toggleHide(property) {
            const id = property.slug;
            let suppressions = [];
            try {
                suppressions = JSON.parse(window.localStorage.getItem('property-suppressions') ?? []);
            } catch(e) {
                // noop
            }
            const index = suppressions.findIndex(favorite => favorite === id);
            if (index >= 0) {
                suppressions.splice(index, 1);
            } else {
                suppressions.push(id);
            }
            window.localStorage.setItem('property-suppressions', JSON.stringify(suppressions));
            let result = this.results.find(result => result.slug === id);
            this.$set(result, 'suppressed', index < 0);
        },
        toggleFavorite(property) {
            let favorites = [];
            try {
                favorites = JSON.parse(window.localStorage.getItem('property-favorites') ?? []);
            } catch(e) {
                // noop
            }
            const index = favorites.findIndex(favorite => favorite === property.slug);
            if (index >= 0) {
                favorites.splice(index, 1);
            } else {
                favorites.push(property.slug);
            }
            window.localStorage.setItem('property-favorites', JSON.stringify(favorites));
            let result = this.results.find(result => result.slug === property.slug);
            this.$set(result, 'favorite', index < 0);
        },


        // doSearch() {
        //     let vue = this;
        //
        //     axios.get('/api/properties', {
        //         params: {
        //             criteria: vue.criteria
        //         }
        //     })
        //         .then(response => {
        //             vue.results.splice(0, vue.results.length, ...response.data);
        //         })
        //         .catch(error => {
        //             console.error(error);
        //         })
        //     ;
        // },
    },
    created() {
        this.VIEWS = {
            form: 1,
            results: 2,
        };
        this.view = this.VIEWS.results;
        if (this.criteria === null) {
            this.resetCriteria();
        }

        this.suppressions.splice(0, this.suppressions.length, JSON.parse(window.localStorage.getItem('property-suppressions') ?? '[]'));
        this.favorites.splice(0, this.favorites.length, JSON.parse(window.localStorage.getItem('property-favorites') ?? '[]'));
        Object.assign(this.criteria, JSON.parse(window.localStorage.getItem('property-criteria') ?? '{}'));

        let vue = this;
        let promises = [];
        promises.push(
            axios.get('/api/towns')
                .then(response => vue.towns.splice(0, vue.towns.length, ...response.data))
        );
        Promise.all(promises)
            .then(() => vue.loading = false)
        ;

        this.debouncedSearch = debounce((page) => {
            let vue = this;

            if (vue.requestController !== null) {
                vue.requestController.abort();
            }
            vue.requestController = new AbortController();
            axios.get('/api/properties', {
                signal: vue.requestController.signal,
                params: {
                    criteria: vue.criteria,
                    // suppressions: JSON.parse(window.localStorage.getItem('property-suppressions')),
                    suppressions: vue.suppressions,
                    sort: vue.sort,
                    page,
                }
            })
                .then(response => {
                    vue.pagination = Object.assign({}, response.data.Pagination);

                    // let suppressions = [];
                    // try {
                    //     suppressions = JSON.parse(window.localStorage.getItem('property-suppressions') ?? []);
                    // } catch(e) {
                    //     // noop
                    // }
                    //
                    // let favorites = [];
                    // try {
                    //     favorites = JSON.parse(window.localStorage.getItem('property-favorites') ?? []);
                    // } catch(e) {
                    //     // noop
                    // }

                    vue.results.splice(0, vue.results.length, ...response.data.Results.map(property => {
                        property.suppressed = vue.suppressions.some(slug => slug === property.slug);
                        property.favorite = vue.favorites.some(slug => slug === property.slug);
                        return property;
                    }));

                    vue.requestController = null;
                })
                .catch(error => {
                    console.error(error);
                    vue.requestController = null;
                })
            ;
        }, 500);
    },
    mounted() {
        // if (this.criteria.myTowns.filter(elm => elm.name.trim() === '').length === 0) {
        //     this.criteria.myTowns.push({show: false, name: ''});
        // }
        this.debouncedSearch();
    }
}
</script>

<style lang="scss">
.propertySearch {
    * {
        font-family: sans-serif;
    }
    .open-search {
        font-size: 12pt;
        cursor: pointer;
        line-height: 0;
        border-style: solid;
        height: 0;
        border-radius: 30px;
        border-width: 15px;
        border-color: #101030;
        background-color: #101030;
        color: white;
    }
    /*
    .modalWrapper {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.85);

        form {
            background-color: white;
            padding: 5vw;
            width: 80%;
            border-radius: 1vw;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
        textarea {
            resize: vertical;
        }
    }
    */

    .clearfix {
        overflow: auto;
    }
}
</style>
